import { Controller } from "stimulus";

// Client-side search for a long dropdown list (e.g. the company chip on the
// tickets index). Filters the item links as the user types so there is no need
// to scroll through every option.
export default class extends Controller {
  static targets = ["input", "item", "empty"];

  filter() {
    const term = this.inputTarget.value.trim().toLowerCase();
    let visibleCount = 0;
    this.itemTargets.forEach((item) => {
      const text = (item.dataset.filterText || item.textContent).toLowerCase();
      const matches = term === "" || text.includes(term);
      item.classList.toggle("hidden", !matches);
      if (matches) visibleCount += 1;
    });
    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visibleCount > 0);
    }
  }

  focus() {
    // Defer so the menu is visible (dropdown#toggle removed `hidden`) before focusing.
    requestAnimationFrame(() => this.inputTarget.focus());
  }
}
